import React, { useEffect } from 'react';
import { io } from 'socket.io-client';

const stories = [
  {
    title: 'Summer schedule update',
    text: 'New service times and refreshed weekly rhythms begin this month for all weekend gatherings.',
    image: 'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1000&q=80',
  },
  {
    title: 'Prayer room reopened',
    text: 'The sanctuary prayer lounge is open for quiet reflection, encouragement, and prayerful care.',
    image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1000&q=80',
  },
  {
    title: 'Community outreach week',
    text: 'Volunteers are preparing thoughtful support for families across the neighborhood.',
    image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1000&q=80',
  },
];

const events = [

{
date:"13 JUL",
title:"Sunday Worship Experience",
time:"8:00 AM & 10:30 AM",
description:"Join us for powerful worship, practical biblical teaching and genuine fellowship."
},

{
date:"16 JUL",
title:"Midweek Prayer Service",
time:"6:00 PM",
description:"A time of prayer, worship and seeking God's direction together."
},

{
date:"19 JUL",
title:"Youth Fellowship",
time:"2:00 PM",
description:"Games, worship, Bible discussion and building friendships in Christ."
},

{
date:"26 JUL",
title:"Community Outreach",
time:"9:00 AM",
description:"Serving families and sharing Christ's love within our neighbourhood."
}

];


const API_BASE_URL = "https://church-backend-48tj.onrender.com";


function NewsPage() {
const [events, setEvents] = React.useState([]);
const [stories, setStories] = React.useState([]);
const [expandedStory, setExpandedStory] = React.useState(null);

 useEffect(() => {
    // socket live adds
    const socket = io(API_BASE_URL, { transports: ['websocket'] });
    socket.on('connect', () => { /* connected */ });
    socket.on('getstory', (prod) => { if (prod) setStories(prev => [prod, ...prev]); });
    socket.on('getevent', (prod) => { if (prod) setEvents(prev => [prod, ...prev]); });
      socket.on('updatestory', (prod) => { if (prod) setStories(prev => [prod, ...prev]); });
    socket.on('updateevent', (prod) => { if (prod) setEvents(prev => [prod, ...prev]); });
    
socket.on('deletestory', (id) => {
   setStories(prev =>
      prev.filter(item => item._id !== id)
   );
});


socket.on('deleteevent', (id) => {
   setEvents(prev =>
      prev.filter(item => item._id !== id)
   );
});

    return () => socket.disconnect();
  }, []);

  const getEvents = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/events`);

        if (!response.ok) {
            throw new Error("Failed to fetch events");
        }

        const data = await response.json();

        setEvents(data);

    } catch (err) {
        console.error(err);
    }
};

const getStories = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/stories`);

        if (!response.ok) {
            throw new Error("Failed to fetch stories");
        }

        const data = await response.json();

        setStories(data);

    } catch (err) {
        console.error(err);
    }
};


useEffect(() => {
    getEvents();
    getStories();
}, []);

  return (
    <div className="page-shell">
      <section className="hero-banner hero-banner--compact" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1433086966358-54859d0ed716?auto=format&fit=crop&w=1600&q=80)' }}>
        <div className="hero-overlay" />
        <div className="hero-content container">
        
          <h1>News & Stories.</h1>
          <p>Everything is presented in a clear and elegant editorial layout that feels calm and current.</p>
        </div>
      </section>


   



<section className="timelinee-section ">

<div className="container">

<div className="timelinee-heading">

<span>UPCOMING AT WRC</span>

<h2>

Join Us In What's Coming Next

</h2>

<p>

Every gathering is an opportunity to worship,
grow and build meaningful relationships.

</p>

</div>

<div className="preview-timeline">

{events.map((item,index)=>(

<div
className="preview-item"
key={item._id || index}
>

<div className="preview-date">

 {new Date(item.date).toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}

</div>

<div className="preview-dot"></div>

<div className="preview-content">

<h3>{item.title}</h3>

<p>{item.description}</p>

<span>{item.time}</span>

</div>

</div>

))}

</div>

</div>

</section>

<section className="section container">
  <div className="card-grid">
    {stories.map((item) => {
      const expanded = expandedStory === item._id;

      return (
        <article className="card" key={item._id}>
          <img
            src={item.image}
            alt={item.title}
            className="card-image"
          />

          <div className="card-body">
            <h3>{item.title}</h3>

            <p className={expanded ? "story-text expanded" : "story-text"}>
              {item.text}
            </p>

            {item.text.length > 100 && (
              <button
                className="read-more-btn"
                onClick={() =>
                  setExpandedStory(expanded ? null : item._id)
                }
              >
                {expanded ? "Show Less" : "Read More"}
              </button>
            )}
          </div>
        </article>
      );
    })}
  </div>
</section>
    </div>
  );
}

export default NewsPage;
